import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ViewportGizmoNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 21.1078L6.34338 17.8406V11.3109L12 8.04492L17.6578 11.3109V17.8429L12 21.1078ZM9.34338 16.1109L12 17.6437L14.6578 16.1085V13.0429L12 11.5089L9.34338 13.0429V16.1109Z"
        fill={color}
      />
      <path d="M13.2 3.49103H10.8V9.03403H13.2V3.49103Z" fill={color} />
      <path
        d="M6.59928 16.3088L1.80078 19.0818L3.0008 21.1584L7.79931 18.3854L6.59928 16.3088Z"
        fill={color}
      />
      <path
        d="M11.5008 1.46882L9.2287 4.87692H14.7714L12.4993 1.46882C12.2618 1.11252 11.7382 1.11252 11.5008 1.46882Z"
        fill={color}
      />
      <path
        d="M0.39892 20.6978C0.20922 21.0816 0.47102 21.535 0.89812 21.5625L4.98562 21.8262L2.21442 17.0262L0.39892 20.6978Z"
        fill={color}
      />
      <path
        d="M23.6011 20.6978L21.7856 17.0262L19.0144 21.8262L23.1019 21.5625C23.5291 21.535 23.7908 21.0816 23.6011 20.6978Z"
        fill={color}
      />
      <path
        d="M17.3994 16.3098L16.2006 18.3871L21.0006 21.1574L22.1995 19.0801L17.3994 16.3098Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ViewportGizmoNsk.displayName = 'ViewportGizmoNsk';
